<template>
  <b-card
    style="max-height: 180px"
    :img-src="img"
    img-alt="Card image cap"
    img-left
  >
    <b-card-title>
      <div class="d-flex align-items-baseline">
        <span class="display-4 text-warning">{{ count }}</span>
        <div class="h3 text-body mx-50">{{ title }}</div>
      </div>
    </b-card-title>
    <b-card-text>
      <div class="h2">{{ subtitle }}</div>
    </b-card-text>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardImg,
  BCardTitle,
  BMedia,
  BMediaAside,
  BCardText,
} from "bootstrap-vue";
export default {
  components: {
    BCard,
    BCardImg,
    BCardTitle,
    BMedia,
    BMediaAside,
    BCardText,
  },
  props: ["count", "title", "subtitle", "img"],
};
</script>
<style lang="scss">
.card-img-left {
  object-fit: cover;
  width: 35%;
}
</style>
